import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
              <i className="ri-hashtag"></i>
              话题热榜
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              大家都在搜
            </h2>
            <p className="text-sm text-foreground-500 mt-2">基于全网实时搜索数据更新</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
            {topicItems.map((item, idx) => (
              <div
                key={item.id}
                className="group relative bg-background-50 border border-background-200 rounded-xl p-4 hover:border-primary-300 transition-all cursor-pointer"
              >
                {idx < 3 && (
                  <div className="absolute -top-2 -left-2 w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center text-xs font-bold text-background-50 shadow-sm">
                    {idx + 1}
                  </div>
                )}
                <div className="flex items-start justify-between gap-2">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-1.5 mb-1.5">
                      {item.isHot && (
                        <span className="flex-shrink-0 px-1.5 py-0.5 text-[10px] font-bold text-accent-600 bg-accent-100 rounded">
                          HOT
                        </span>
                      )}
                      <h3 className="font-sans text-sm font-semibold text-foreground-900 truncate">
                        {item.name}
                      </h3>
                    </div>
                    <div className="flex items-center gap-2 text-xs">
                      <span className="text-foreground-500">{item.heat}</span>
                      <span className={item.trend === 'up' ? 'text-primary-500' : item.trend === 'down' ? 'text-foreground-400' : 'text-secondary-600'}>
                        <i className={`${item.trend === 'up' ? 'ri-arrow-up-line' : item.trend === 'down' ? 'ri-arrow-down-line' : 'ri-subtract-line'} text-xs`}></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}